import { createFileRoute } from '@tanstack/react-router'
import { decodeTasksSearch } from '~/components/tasks/search'
import { TaskBoard } from '~/components/tasks/task-board'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/tasks/')({
  component: TasksIndex,
  validateSearch: decodeTasksSearch,
})

function TasksIndex() {
  return <TaskBoard />
}
